import { DatesResponse } from 'types/Meteorology/Agro/TrackingForecast/DetailedView/getDates';
import { TimeFrequenciesResponse, TimeFrequency } from 'types/Meteorology/Agro/TrackingForecast/DetailedView/getTimeFrequencies';
import { VariableResponse, Variable } from 'types/Meteorology/Agro/TrackingForecast/DetailedView/variable';
import {
  ListAgroTrackingForecastPreferencesResponse,
} from 'types/Meteorology/Agro/TrackingForecast/DetailedView/listPreferences';
import { AgroTrackingForecastPreference } from 'types/Meteorology/Agro/TrackingForecast/DetailedView/preference';

export const transformGetTimeFrequencies = (
  response: TimeFrequenciesResponse,
): TimeFrequency[] => response.data.map((item) => ({
  label: item.label,
  value: item.nome,
}));

export const transformGetVariables = (
  response: VariableResponse,
): Variable[] => (
  response.data.map((variable) => ({
    value: variable.nome,
    label: variable.label,
  }))
);

export const transformGetDates = (response: DatesResponse): string[] => response.data;

export const transformListPreferences = (
  response: ListAgroTrackingForecastPreferencesResponse,
): AgroTrackingForecastPreference[] => response.data.map((preference) => ({
  id: preference.id,
  name: preference.name,
  submenu: preference.json_p.submenu,
  params: {
    ...(({ submenu, ...rest }) => rest)(preference.json_p),
  },
}));
